const getContactPerson = (auth : any) => {
    const contact = auth.displayName.includes("|")
    ? auth.displayName.split("|")[0].trim()
    : auth.displayName.trim();

    return contact

}

export default getContactPerson;